// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Cttl","title":"InfoRow_title__2Zt-W"};